import React, { Component } from "react";
import Tweet from "./Tweet";
import db from "../firebase";

export default class Profile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      posts: [
        {
          img: "",
          id: 99,
          likes: 2300000000,
          date: "12:22 - Jan 08 2021",
          text: "Twitter Who?",
        },
        {
          id: 6,
          text: "Dinosaurs are a lie!",
          img: "",
          likes: 4900000000,
          date: "12:45 - Jan 09 2021",
        },
        {
          img: "",
          id: 5,
          date: "13:47 Jan 09 2021",
          likes: 560000000,
          text: "I have never seen a thin person drinking Diet Coke",
        },
        {
          img: "https://i.imgflip.com/1iclio.jpg?a447000",
          text:
            "You wanna see an image of the real voting result? Here you go:",
          likes: 9100000000,
          id: 2,
          date: "12:53 - 10 Jan 2021",
        },
        {
          id: 1,
          likes: 215000000,
          text:
            "Why do I get only 23.1 Quintillion likes? I deserve more! Trumper should fix this or I will ban it!",
          img: "",
          date: "13:03 - Jan 10 2021",
        },
        {
          id: 0,
          date: "12:43 - Jan 10 2021",
          likes: 420000000,
          emoji: true,
          img: "",
          text:
            "I am the best president of all times. Chickens don't exist. Trump Tower is taller than Mount Everest. Facts!",
        },
        {
          date: "13:14 - Jan 10 2021",
          id: -1,
          text:
            'Last week I went to the doctor. Results came in: "Strongest and sexiest man of america." Tell me something new, doc!',
          img: "",
          likes: 456000000,
        },
        {
          id: -4,
          text: "Somebody give this man an award!",
          img: "https://i.gyazo.com/9ebec007562acccad4129a437d52673f.png",
          emoji: true,
          date: "09:21 - Jan 11 2021",
          likes: 3400000000,
        },
        {
          date: "15:21 - Jan 11 2021",
          id: -10,
          likes: 9750000000,
          img: "",
          text:
            "It's freezing and snowing in New York-- we need global warming!",
        },
      ],
    };
  }

  componentDidMount() {
    /*db.collection("posts")
      .orderBy("id", "desc")
      .onSnapshot((snapshot) => {
        const data = snapshot.docs.map((doc) => doc.data());
        console.log(data);
        this.setState({
          posts: data.reverse(),
        });
      });*/
  }

  render() {
    return (
      <div className="profile">
        <div className="bg">
          <div className="profileImage">
            <img
              src="https://static01.nyt.com/newsgraphics/2019/08/01/candidate-pages/3b31eab6a3fd70444f76f133924ae4317567b2b5/trump-circle.png"
              alt=""
            />
          </div>

          <div onClick={playWrong} className="reportButton">
            <i class="bi bi-flag"></i> Report
          </div>
        </div>

        <div className="userInfo">
          <h1>
            Donald J. Trump
            <svg
              title="Verified (This is the real Donald Trump)"
              viewBox="0 0 24 24"
              aria-label="Verified account"
              class="r-13gxpu9 r-4qtqp9 r-yyyyoo r-1xvli5t r-dnmrzs r-bnwqim r-1plcrui r-lrvibr"
            >
              <g>
                <path
                  fill="#f20000"
                  d="M22.5 12.5c0-1.58-.875-2.95-2.148-3.6.154-.435.238-.905.238-1.4 0-2.21-1.71-3.998-3.818-3.998-.47 0-.92.084-1.336.25C14.818 2.415 13.51 1.5 12 1.5s-2.816.917-3.437 2.25c-.415-.165-.866-.25-1.336-.25-2.11 0-3.818 1.79-3.818 4 0 .494.083.964.237 1.4-1.272.65-2.147 2.018-2.147 3.6 0 1.495.782 2.798 1.942 3.486-.02.17-.032.34-.032.514 0 2.21 1.708 4 3.818 4 .47 0 .92-.086 1.335-.25.62 1.334 1.926 2.25 3.437 2.25 1.512 0 2.818-.916 3.437-2.25.415.163.865.248 1.336.248 2.11 0 3.818-1.79 3.818-4 0-.174-.012-.344-.033-.513 1.158-.687 1.943-1.99 1.943-3.484zm-6.616-3.334l-4.334 6.5c-.145.217-.382.334-.625.334-.143 0-.288-.04-.416-.126l-.115-.094-2.415-2.415c-.293-.293-.293-.768 0-1.06s.768-.294 1.06 0l1.77 1.767 3.825-5.74c.23-.345.696-.436 1.04-.207.346.23.44.696.21 1.04z"
                ></path>
              </g>
            </svg>
          </h1>
          <span className="username">@realdonaldtrump</span>

          <p className="bio">
            The official anti-fake-news account of the one and only Donald J.
            Trump. 100% real news. I promise. Really.{" "}
            <img
              src="https://i.gyazo.com/d41deb7bfba54991792ec39f01bccef8.png"
              height="25"
              style={{ marginBottom: "-5px" }}
            />
          </p>

          <div className="meta">
            <div className="location">
              <i class="bi bi-geo-alt"></i>
              In the White House
            </div>
            <div className="joined">
              <i class="bi bi-calendar3"></i>
              Joined Jan. 08, 2021
            </div>
          </div>

          <div className="stats">
            <div className="following">
              <strong>0</strong> Following
            </div>
            <div className="followers">
              <strong>16.4 Billion</strong> Followers
            </div>
          </div>

          <span className="follower_notice">
            This account is followed by everybody.
          </span>
        </div>

        <div className="tweets">
          {this.state.posts.reverse().map((post, index) => {
            return (
              <Tweet
                key={post.id}
                date={post.date}
                text={post.text}
                img={post.img}
                likes={post.likes}
                emoji={post.emoji}
              />
            );
          })}
        </div>
      </div>
    );
  }
}

const wrong = new Audio("https://www.gisbefreit.at/js/files/wrong.mp3");
wrong.volume = 0.5;

const playWrong = (e) => {
  wrong.play();
  e.target.classList.add("report--clicked");
  setTimeout(() => e.target.classList.remove("report--clicked"), 801);
};
